import React from "react";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import Box from "@mui/material/Box";
import PropTypes from "prop-types";
import { IconWrapper } from "./styled/Tooltip.styled";

export default function RadioSelectGroup({
  showLabelId,
  labelId,
  showLabel1,
  label1,
  labelOverride1,
  icon1,
  showLabel2,
  label2,
  labelOverride2,
  icon2,
  showLabel3,
  label3,
  labelOverride3,
  icon3,
  showLabel4,
  label4,
  labelOverride4,
  icon4,
  setSelectedValue,
  value,
  ...props
}) {
  const handleChange = (event) => {
    setSelectedValue(event.target.value);
  };
  const controlProps = (item) => ({
    inputProps: { "aria-label": item },
  });

  return (
    <div style={{ width: "100%" }}>
      <FormControl style={{ width: "100%" }}>
        {showLabelId && <FormLabel id={labelId}>{labelId}</FormLabel>}
        <RadioGroup
          column
          aria-labelledby={labelId}
          name={labelId}
          value={value}
          onChange={handleChange}
          style={{ width: "100%" }}
        >
          {showLabel1 && (
            <div style={{ display: "flex", alignItems: "center" }}>
              <div>
                <IconWrapper>
                  <img src={icon1 || "/assets/signal.png"} alt="logo1" width="13" />
                </IconWrapper>
              </div>
              <div style={{ width: "95%" }}>
                <FormControlLabel
                  value={label1}
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                    marginLeft: "8px",
                  }}
                  control={
                    <Radio
                      {...controlProps({ label1 })}
                      sx={{
                        "& .MuiSvgIcon-root": {
                          fontSize: 16,
                        },
                        zIndex: 0
                      }}
                    />
                  }
                  labelPlacement={"start"}
                  label={
                    <Box component="div" fontSize={13}>
                      {label1 === "RSRP" ? "Signal Strength" : label1 === "Data_Received" ? "Data Received" : labelOverride1 ? labelOverride1 : label1}
                    </Box>
                  }
                />
              </div>
            </div>
          )}
          {showLabel2 && (
            <div style={{ display: "flex", alignItems: "center" }}>
              <div>
                <IconWrapper>
                  <img src={icon2 || "/assets/download.png"} alt="logo1" width="13" />
                </IconWrapper>
              </div>
              <div style={{ width: "95%" }}>
                <FormControlLabel
                  value={label2}
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                    marginLeft: "8px"
                  }}
                  control={
                    <Radio
                      {...controlProps({ label2 })}
                      sx={{
                        "& .MuiSvgIcon-root": {
                          fontSize: 16,
                        },
                        zIndex: 0
                      }}
                    />
                  }
                  labelPlacement={"start"}
                  label={
                    <Box component="div" fontSize={13}>
                      {label2 ===  "Data_Transceived" ? "Data Transceived" : labelOverride2 ? labelOverride2 : label2}
                    </Box>
                  }
                />
              </div>
            </div>
          )}
          {showLabel3 && (
            <div style={{ display: "flex",  alignItems: "center"}}>
              <div>
                <IconWrapper>
                  <img src={icon3 || "/assets/upload.png"} alt="logo1" width="13" />
                </IconWrapper>
              </div>
              <div style={{ width: "95%" }}>
                <FormControlLabel
                  value={label3}
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                    marginLeft: "8px"
                  }}
                  control={
                    <Radio
                      {...controlProps({ label3 })}
                      sx={{
                        "& .MuiSvgIcon-root": {
                          fontSize: 16,
                        },
                        zIndex: 0
                      }}
                    />
                  }
                  labelPlacement={"start"}
                  label={
                    <Box component="div" fontSize={13}>
                      {label3 === "Data_Transmit" ? "Data Transmitted" : labelOverride3 ? labelOverride3 : label3}
                    </Box>
                  }
                />
              </div>
            </div>
          )}

          {showLabel4 && (
            <div style={{ display: "flex",  alignItems: "center"}}>
              <div>
                <IconWrapper>
                  <img src={icon4 || "/assets/upload.png"} alt="logo1" width="13" />
                </IconWrapper>
              </div>
              <div style={{ width: "95%" }}>
                <FormControlLabel
                  value={label4}
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                    marginLeft: "8px"
                  }}
                  control={
                    <Radio
                      {...controlProps({ label4 })}
                      sx={{
                        "& .MuiSvgIcon-root": {
                          fontSize: 16,
                        },
                        zIndex: 0
                      }}
                    />
                  }
                  labelPlacement={"start"}
                  label={
                    <Box component="div" fontSize={13}>
                      {labelOverride4 ? labelOverride4 : label4}
                    </Box>
                  }
                />
              </div>
            </div>
          )}
        </RadioGroup>
      </FormControl>
    </div>
  );
}

RadioSelectGroup.propTypes = {
  showLabelId: PropTypes.bool,
  labelId: PropTypes.func,
  showLabel1: PropTypes.bool,
  label1: PropTypes.func,
  showLabel2: PropTypes.bool,
  label2: PropTypes.func,
  showLabel3: PropTypes.bool,
  label3: PropTypes.func,
  showLabel4: PropTypes.bool,
  label4: PropTypes.func,
  setSelectedValue: PropTypes.func,
};

RadioSelectGroup.defaultProps = {
  showLabelId: false,
  labelId: null,
  showLabel1: false,
  label1: null,
  showLabel2: false,
  label2: null,
  showLabel3: false,
  label3: null,
  showLabel4: false,
  label4: null,
  setSelectedValue: () => {},
};
